module.exports = __webpack_public_path__ + "static/media/w_w_hw_12.89880a19.png";